import type { Context } from "./models/context";

export const checkExceedsTimesAllowedToCompletePerEvent = (
  context: Context,
) => {
  if (context.selection.allocationId === context.allocation.id) return false;

  const timesAllowedToComplete =
    context.automation.requirements[0].userDrivenAttributes
      ?.timesAllowedToCompletePerEvent!;

  const automationId = context.automation.automationId;
  const eventIdUsages = context.allocation.attributes?.eventIdUsages || {}; // record of numbers per eventId

  const currentCount = context.selection.outcomes.reduce(
    (totalUsages, outcome) => {
      const eventId = outcome.eventId;

      // 1. Get usages from automation for this eventId
      const pastEventIdUsagesForCurrentEvent = eventIdUsages[eventId] ?? 0;

      // 2. get usages from betslip context
      const futureEventIdUsagesForCurrentEvent =
        (context.usages[automationId]?.[eventId] || []).length ?? 0;

      totalUsages +=
        pastEventIdUsagesForCurrentEvent + futureEventIdUsagesForCurrentEvent;

      return totalUsages;
    },
    0,
  );

  return currentCount >= timesAllowedToComplete;
};

const markAsUsed = (context: Context) => {
  const { allocation, usedAllocations } = context;
  let usedAtOutcomeId = null;

  if (typeof usedAllocations[allocation.id] !== "undefined") {
    // this allocation is already used in on a different selection
    // find out which one is it, and set usedAt to the outcomeId of that selection
    usedAtOutcomeId = usedAllocations[allocation.id];
  }

  const requiresCheck =
    typeof context.automation.requirements?.[0].userDrivenAttributes
      ?.timesAllowedToCompletePerEvent !== "undefined";

  if (requiresCheck && checkExceedsTimesAllowedToCompletePerEvent(context)) {
    // this allocation exceeds the rules of times allowed to complete
    // we can grab any allocation used from this automation and set it as the one that is used

    const eventId = context.selection.eventIds.values().next().value!;
    const usedAllocationId =
      context.usages[context.automation.automationId]?.[eventId]?.[0];

    if (!usedAllocationId) return allocation;

    usedAtOutcomeId = usedAllocations[usedAllocationId];
  }

  return {
    ...allocation,
    usedAtOutcomeId,
  };
};

export { markAsUsed };
